<template>
  <div class="contact-infor-mation">
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="80">
      <FormItem label="联系人"
                prop="name">
        <Input class="input"
               v-model="formValidate.name"
               :maxlength="4"
               @on-keyup="inputChinese('name')"
               placeholder="请填写全名，方便我们与您联系" />
      </FormItem>
      <FormItem label="手机号"
                prop="tel">
        <Input class="input"
               :maxlength="11"
               @input="inputNumber('tel')"
               v-model="formValidate.tel"
               placeholder="本号码将应用于接收用户名和密码、账号登录" />
      </FormItem>
      <FormItem label="验证码"
                prop="code"
                style="position:relative">
        <Input class="input"
               :maxlength="6"
               @input="inputNumber('code')"
               v-model="formValidate.code"
               placeholder="请填写短信验证码" />
        <span :class="['get-code', timeButton === '获取验证码' ? '' : 'not-allow']"
              @click="getCode"
              v-text="timeButton"></span>
      </FormItem>
      <FormItem>
        <div id="sc"></div>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="handleSubmit('formValidate')">下一步</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  data () {
    return {
      formValidate: {
        name: '',
        tel: '',
        code: ''
      },
      ruleValidate: {
        name: [
          {
            required: true,
            trigger: 'blur',
            message: '联系人不能为空',
            validator: this.validateSelect,
            _this: this
          },
          {
            required: true,
            trigger: 'blur',
            pattern: /[\u4e00-\u9fa5]{2,4}$/,
            message: '联系人必须为2-4个汉字',
            validator: this.validateStringReg,
            _this: this
          }
        ],
        tel: [
          {
            required: true,
            trigger: 'blur',
            message: '手机号不能为空',
            validator: this.validateSelect,
            _this: this
          },
          {
            required: true,
            trigger: 'blur',
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号格式不正确',
            validator: this.validateStringReg,
            _this: this
          }
        ],
        code: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入验证码',
            validator: this.validateSelect,
            _this: this
          }
        ]
      },
      // 获取验证码按钮文本
      timeButton: '获取验证码',
      timer: null,
      seconds: 0,
      aliVerify: null
    }
  },
  created () {
    this.$emit('changeLine', 1)
    const oldFormData = this.getSessionStorage('userInfo')
    if (oldFormData) {
      this.formValidate = {
        ...this.formValidate,
        ...oldFormData
      }
    }
  },
  mounted () {
    this.initAliVerify()
  },
  methods: {
    initAliVerify () {
      if (!window.aliVerify) return
      this.aliVerify = window.aliVerify.createVerify({
        success: this.sendVerificationTel
      })
    },
    // 获取短信验证码
    getCode () {
      if (this.timeButton !== '获取验证码') return
      this.$refs.formValidate.validateField('tel', err => {
        if (!err) {
          if (!this.aliVerify) {
            this.initAliVerify()
          }
          if (!this.aliVerify) {
            this.$showToast.show({
              text: '验证组件加载失败，请刷新重试',
              type: 'error',
              time: 1800
            })
            return
          }
          this.aliVerify.verify()
        }
      })
    },
    // 阿里验证通过后发送短信验证码
    sendVerificationTel (captchaVerifyParam) {
      this.$showToast.show({
        text: '加载中...',
        type: 'loading',
        time: 6000
      })
      this.$api
        .getVerificationTel({
          phone_num: this.formValidate.tel,
          token: captchaVerifyParam,
          version: '2.0'
        })
        .then(res => {
          this.handleVerificationTel(res.data)
        })
        .catch(err => {
          console.log(err)
          this.$showToast.hide()
          this.$showToast.show({
            text: '验证失败',
            type: 'error',
            time: 1800
          })
        })
    },
    // 短信验证码接口回调
    handleVerificationTel (data) {
      console.log('handleVerificationTel', data)
      this.$showToast.hide()
      const code = Number(data.code)
      const alicode = Number(data.alicode)
      const isFail = data.status === 0 || [900, 800, 904].includes(alicode) || [5001, 5005, 500].includes(code)
      if (isFail) {
        if (code === 5005) {
          this.timeButton = '请明日再试'
        }
        this.$showToast.show({
          text: data.data && data.data.tips ? data.data.tips : '发送失败',
          type: 'error',
          time: 1800
        })
      } else {
        // 倒计时
        this.updateTime()
        this.$showToast.show({
          text: data.data && data.data.tips ? data.data.tips : '发送成功',
          type: 'success',
          time: 2000
        })
      }
    },
    // 获取验证码定时器
    updateTime () {
      console.log('更新时间', this.seconds)
      this.seconds = 60
      let _this = this
      _this.timeButton = _this.seconds + 's后重新获取'
      // eslint-disable-next-line no-undef
      this.timer = setInterval(function () {
        _this.seconds--
        _this.timeButton = _this.seconds + 's后重新获取'
        if (_this.seconds === 0) {
          _this.timeButton = '获取验证码'
          _this.timer && clearInterval(_this.timer)
          return 1
        }
      }, 1000)
    },
    // 下一步
    handleSubmit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api
            .getDealerRegister({
              phone_num: this.formValidate.tel,
              link_man: encodeURIComponent(this.formValidate.name),
              captcha: this.formValidate.code
            })
            .then(res => {
              const { code, data } = res.data
              console.log(code, data)
              if (code === 500) {
                this.$showToast.show({
                  text: data.tips,
                  type: 'error',
                  time: 1800
                })
              } else if (code === 200) {
                // 存储经销商信息
                const json = {
                  dealer_id: data.dealer_id,
                  dealer_key: data.dealer_key
                }
                this.setStorage('dealerInfo', json)
                const obj = {
                  name: this.formValidate.name,
                  tel: this.formValidate.tel
                }
                this.setSessionStorage('userInfo', obj)
                this.$router.push('CompanyInformation')
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      })
    },
    // 输入数字
    inputNumber (dom) {
      if (this.timeButton !== '获取验证码') {
        this.timeButton = '获取验证码'
        this.timer && clearInterval(this.timer)
        this.seconds = 60
      }
      this.$nextTick(() => {
        this.formValidate[dom] = this.formValidate[dom].replace(/[^\d]/g, '')
      })
    },
    // 输入汉字
    inputChinese (dom) {
      this.$nextTick(() => {
        this.formValidate[dom] = this.formValidate[dom].replace(/[^\u4e00-\u9fa5]/g, '')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.contact-infor-mation {
  width: 400px;
  margin: 0 auto;
  transform: translate(-26px, 0);
  .input {
    background: #ffffff;
    border: 1px solid #e4e5e6;
    border-radius: 4px;
    overflow: hidden;
  }
  .get-code {
    display: block;
    text-align: center;
    width: 100px;
    height: 31px;
    background-color: #2d8cf0;
    position: absolute;
    right: 1px;
    top: 2px;
    border-radius: 0 3px 3px 0;
    color: #ffffff;
    cursor: pointer;
  }
}
// 按钮禁用
.not-allow {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}
.ivu-btn {
  width: 318px;
  // margin-left: -60px;
}
// 覆盖
/deep/.nc-container .nc_scale span {
  height: 34px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/DealerRegister/ContactInformation.vue